import IntlProps from "../../state/helpers/IntlProps"
import {
    getItemQuantities,
} from "../../state/selection/selectionSelectors"
import {
    editItemQuantity,
} from "../../state/selection/selectionActions"
import {connect, ConnectedProps} from "react-redux"
import {defineMessages, FormattedMessage, injectIntl} from "react-intl"
import InputUnitOfMeasure from "../../common/unit-of-measure/input.component"
import React from "react"
import {ProposalItemDto} from "../../state/proposal/Proposal"

const messages = defineMessages({
    modal_active_items_label: {
        id: "price_list.configure_price_list_modal.active_items",
        defaultMessage: "Active items",
    },
})


type OwnProps = {
    activeItems: ProposalItemDto[]
}


const ActiveItemSelectionComponent = (props: Props & IntlProps) => {

    const getItemQuantity = (item: ProposalItemDto): string => {
        const editableItem = props.itemQuantities.find(i => i.itemId === item.id)
        return editableItem ? editableItem.measure : item.measure
    }

    return (
        <div className="mb-3 pt-2">
            <h5>
                <FormattedMessage{...messages.modal_active_items_label}/>
            </h5>

            {props.activeItems.map(p => {
                return (
                    <>
                        <div className="form-group form-row border-bottom border-top py-2 mb-0">
                            <div className="col-2">
                                <InputUnitOfMeasure
                                    name={"measure"}
                                    id={"measure"}
                                    value={getItemQuantity(p)}
                                    onChange={measure => {props.editItemQuantity(p.id, measure)}}
                                    disabled={!p.isEditableQuantity}
                                />
                            </div>

                            <label className="col-7 col-form-label text-align-left">
                                <span className="ml-3">
                                    {p.title}
                                </span>
                            </label>
                        </div>
                    </>
                )
            })
            }
        </div>
    )
}


const mapState = (state, props: OwnProps) => {
    return {
        ...props,
        itemQuantities: getItemQuantities(state),
    }
}
const mapDispatch = {
    editItemQuantity,
}

const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(ActiveItemSelectionComponent))


// WEBPACK FOOTER //
// ./src/price-list/components/ActiveItemSelectionComponent.tsx